module.exports = __webpack_public_path__ + "img/logo_login.1bc8d31b.png";